import React, { Fragment } from 'react'

export const About = () => {
    return (
        <Fragment>
            <h1>About This App</h1>
            <p>App to search Github users</p>
            <p>Version:1.0.0</p>
            <p>Created: 24 September 2020</p>
            <p>Courtesy: Brad Traversy </p>
            <i>nymhsn13@gmail.com</i>
        </Fragment>
    )
}
export default About;
